import { render, staticRenderFns } from "./needDetail.vue?vue&type=template&id=6c3d2019&scoped=true"
import script from "./needDetail.vue?vue&type=script&lang=js"
export * from "./needDetail.vue?vue&type=script&lang=js"
import style0 from "./needDetail.vue?vue&type=style&index=0&id=6c3d2019&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c3d2019",
  null
  
)

export default component.exports